/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Table, theme, SVGIcon, Text } from "@nordcloud/gnui";
import { TRANSITION } from "~/constants/theme";

export const StyledTh = styled(Table.th)`
  font-size: ${theme.fontSizes.sm} !important;
  letter-spacing: normal;
  color: ${theme.color.text.text02};
  font-weight: ${theme.fontWeights.medium};
  cursor: pointer;
`;

export const StyledThV2 = styled(Table.th)<{ isSortable?: boolean }>`
  font-size: ${theme.fontSizes.sm} !important;
  padding: ${theme.spacing.spacing02} ${theme.spacing.spacing03} !important;
  letter-spacing: normal;
  color: ${theme.color.text.text02};
  background-color: ${theme.color.background.ui03};
  font-weight: ${theme.fontWeights.medium};
  ${({ isSortable }) =>
    isSortable ?? false
      ? `
        cursor: pointer;
        &:hover {
          background-color: ${theme.color.background.ui04};
          cursor: pointer;
        }`
      : ""}
`;

export const StyledTd = styled(Table.td)`
  vertical-align: middle;
`;

export const StyledRow = styled(Table.tr)`
  &.interactive {
    transition: opacity ${TRANSITION.default};

    &:hover {
      opacity: 0.7;
      cursor: pointer;
    }
  }
`;

export const SVGIconDark = styled(SVGIcon)`
  margin-left: ${theme.spacing.spacing01};
  transform: translateY(3px);
`;

export const SVGIconLight = styled(SVGIcon)`
  margin-left: ${theme.spacing.spacing01};
  transform: translateY(3px);
  fill: ${theme.color.text.text02};
`;

export const StyledTable = styled(Table)<{ mb?: string }>`
  margin-bottom: ${(props) => props.mb || theme.spacing.spacing07};
`;

export const CostForecastHeader = styled(Text)`
  color: ${theme.color.text.text02};
  text-align: right;
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.medium};
  margin-bottom: ${theme.spacing.spacing00};
`;
